import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import queryString from 'query-string';

import ExportRangeModal from "components/base/ExportRangeModal";
import ListButtonsGroup from "components/base/ListButtonsGroup";
import AuthButton from "components/base/AuthButton";
import BaseTabListContainer from "containers/base/BaseTabListContainer";
import BaseListContainer from "containers/base/BaseListContainer";
import CustomListComponent from "components/base/CustomListComponent";
import CustomBreadcrumb from "components/base/CustomBreadcrumb";
import MerchantRemarkSettingModal from "components/merchantAppRecord/MerchantRemarkSettingModal";
import { ImportResource } from "models/DownloadImportModel";
import { NavBarNames } from "config/NavBarNameList";
import { PermissionCodes } from "config/PermissionCodes";
import { ADMINISTRATOR_TYPES } from "config/CustomEnums";
import { ArrayStringData, createAction, getListInFilterValue } from "utils";

import Filter from "./Filter";

const mapPropsToState = ({ merchantAppRecords }) => ({
  pagedList: merchantAppRecords.pagedList,
  totalCount: merchantAppRecords.totalCount,
  pageInfo: merchantAppRecords.pageInfo,
  totalPage: merchantAppRecords.totalPage,
  listDisplayFields: merchantAppRecords.listDisplayFields,
  checkedList: merchantAppRecords.checkedList,
});
const MerchantAppRecordList = ({
  pagedList,
  totalCount,
  pageInfo,
  totalPage,
  listDisplayFields,
  checkedList,
}) => {
  const [isExportAll, setIsExportAll] = useState(true);
  const [showExportModal, setShowExportModal] = useState(false);

  const [showSettingModal, setShowSettingModal] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const searchDict = queryString.parse(location.search);

  const fetchDataForFilter = () => {
    const searchStores = ArrayStringData(searchDict["store"] || '');
    const searchMerchantAdmin = ArrayStringData(searchDict["merchant_admin"] || '');
    if (searchStores?.length > 0) {
      dispatch(
        createAction('storeModel/getSelectedAllList')({
          isSimpleNode: true,
          idIn: searchStores,
        })
      )
    }
    if (searchMerchantAdmin?.length > 0) {
      dispatch(
        createAction('admin/getAllSelectedAdmins')({
          adminType: ADMINISTRATOR_TYPES.MERCHANT_APP_ACCOUNT,
          idIn: searchMerchantAdmin,
        })
      )
    }
  }

  const fetchListData = () => {
    const stringRank = searchDict['rank'] || 'true';
    const rank = stringRank === 'true';
    const stringPage = searchDict['page'] || 1;

    dispatch(
      createAction('merchantAppRecords/getList')({
        ...searchDict,
        rank,
        page: stringPage,
        ...getFilterData(),
      })
    );
  }
  const getFilterData = () => {
    const merchantAdminIn = searchDict["merchant_admin"]
    const createDatePeriod = searchDict?.creation_date?.split(',');
    const creationDateGte = createDatePeriod?.[0]
    const creationDateLte = createDatePeriod?.[1]
    const storeIn = searchDict["store"]
    const membershipIdIcontains = searchDict.search
    return {
      merchantAdminIn,
      creationDateGte,
      creationDateLte,
      storeIn,
      membershipIdIcontains,
    }
  }

  const exportCSVAction = () => {
    const checkedMerchantRecord = (checkedList || []).map(item => item.pk);
    const {
      merchantAdminIn,
      creationDateGte,
      creationDateLte,
      storeIn,
      membershipIdIcontains,
    } = getFilterData();


    dispatch(createAction('downloadAndImport/createDownloadTask')({
      from: ImportResource.merchantAppRecord,
      related: isExportAll ? {} : {
        idIn: checkedMerchantRecord,
        creationDateGte,
        creationDateLte,
        merchantAdminIn: merchantAdminIn ? getListInFilterValue(merchantAdminIn) : null,
        storeIn: storeIn ? getListInFilterValue(storeIn) : null,
        membershipIdIcontains,
      },
    }))
  }
  
  useEffect(()=> {
    return () => {
      dispatch(createAction('merchantAppRecords/clearData')());
      dispatch(createAction('storeModel/clearData')());
      dispatch(createAction('admin/clearData')());
    };
  },[dispatch])

  useEffect(() => {
    fetchListData();
    fetchDataForFilter();
  }, [dispatch, location]);

  const listButtons = [
    <ListButtonsGroup
      hideExtraButtonWidth={600}
      hideAllButtonWidth={530}
      primaryButton={[
        <AuthButton
          title={'Export'}
          action={() => setShowExportModal(true)}
          requires={PermissionCodes.addExportjob}
        />,
      ]}
      primaryPopContent={[
        {
          requires: PermissionCodes.addExportjob,
          action: () => setShowExportModal(true),
          content: 'Export',
        },
      ]}
      extraButtons={[
        <AuthButton
          customClass="btn-back-button-common btn-download"
          title="Setting"
          action={() => {
            setShowSettingModal(true);
          }}
          requires={PermissionCodes.viewMerchantAppRemarkSetting}
        />,
      ]}
    />,
  ]

  const listTabs = [
    {
      name: '',
      content: (
        <BaseTabListContainer
          hideTab={true}
          groupActions={[]}
          pageInfo={pageInfo}
          totalCount={totalCount}
          filter={{
            hasFilter: true,
            component: Filter,
          }}
          searchPlaceholder={"Search by membership id"}
          listContent={
            <BaseListContainer
              fields={listDisplayFields}
              dataList={pagedList}
              totalPage={totalPage ? totalPage : 0}
              deleteInfo={{
                data: [],
                title: '',
                relatedName: '',
                onComfirm: {},
              }}
              hideActions={true}
              model={'merchantAppRecords'}
              permissionGroup={PermissionCodes.merchantAdminRecord}
              customClassName="coupon-record-table"
            />
          }
        />
      ),
    }
  ]

  return (
    <>
      <CustomListComponent
        title={NavBarNames.merchantAppRecords}
        buttons={listButtons}
        breadcrumb={<CustomBreadcrumb />}
        hideTab={true}
        tabs={listTabs}
      />
      <ExportRangeModal
        show={showExportModal}
        title={`Export Merchant App Records`}
        closeAction={() => {
          setShowExportModal(false)
        }}
        rightButton={{
          text: 'Export',
          action: () => {
            exportCSVAction()
            setShowExportModal(false)
          },
          requires: PermissionCodes.addExportjob,
        }}
        isExportAll={isExportAll}
        setIsExportAll={setIsExportAll}
      />
      <MerchantRemarkSettingModal
        show={showSettingModal}
        closeAction={() => setShowSettingModal(false)}
      />
    </>)
}

export default connect(mapPropsToState)(MerchantAppRecordList);